import { render, staticRenderFns } from "./stored-value-detail.vue?vue&type=template&id=27dfd258"
import script from "./stored-value-detail.vue?vue&type=script&lang=js"
export * from "./stored-value-detail.vue?vue&type=script&lang=js"
import style0 from "./stored-value-detail.vue?vue&type=style&index=0&id=27dfd258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports